import * as Scrivito from "scrivito";
import React from "react";
import { useBeforeUnload } from "hooks/useBeforeUnload";
import { useProject, useProjectActions } from "stores/project";
import { useOnFocus } from "hooks/useOnFocus";

const Component = React.memo(() => {
  const { refetch: refetchProject } = useProjectActions();
  const project = useProject();
  useOnFocus(() => project?.id && refetchProject(), 5);
  useBeforeUnload();
  return <></>;
});

export const CallHooks = Scrivito.connect(() => <Component />);
